export const CUSTOM_EVENTS = {
  UNAUTHORIZED_EVENT: 'unauthorizedEvent',
  RESTRICTED_EVENT: 'restrictedEvent',
};

export type UnauthorizedEvent = CustomEvent<{ referer: string }>;
export type RestrictedEvent = CustomEvent<{ referer: string, code: 401 | 403 }>;
